import moment from "moment";
import { useForm } from "react-hook-form";

const MachineOperatorAssociationFilter = ({ setDuration }) => {
    const { handleSubmit, register } = useForm({
        defaultValues: {
            date: moment().format("YYYY-MM-DD"),
        },
    });

    const onSubmit = (data) => {
        setDuration(moment(data?.date).format("YYYY-MM-DD"));
    };

    return (
        <div
            className="modal fade m-0 p-0"
            tabIndex={-1}
            id="machine-operator-association-filter-modal"
            aria-modal
        >
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Filter</h5>
                        <button
                            type="button"
                            className="close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        >
                            <em className="icon ni ni-cross" />
                        </button>
                    </div>

                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="modal-body">
                            <div className="row g-3 w-100">
                                <div className="col-12">
                                    <label className="form-label mb-0">
                                        Date:
                                    </label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        {...register("date")}
                                        onWheel={(e) => e.target.blur()}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer bg-light">
                            <button
                                type="submit"
                                className="btn btn-primary"
                                data-bs-dismiss="modal"
                            >
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default MachineOperatorAssociationFilter;
